// extracted by mini-css-extract-plugin
module.exports = {"swatch":"colourSwatch-module__swatch___CkMGA","whiteSwatch":"colourSwatch-module__whiteSwatch___3TW3C"};